<template>
    <div class="map-scale-panel" v-on:click="showhelp = true">
            <!--Removes scale from print preview-->
            <div class="map-scale-head">
               {{ $t('printComponent.scaleHeader') }} 1:{{ Math.round(scale) }}
            </div>
        <div :style="{ width: `${scaleWidth}px` }" class="map-scale">
            <div class="map-scale-part">
                <label class="map-scale-part-label">{{
                    scaleReadObject.parts[0]
                }}</label>
            </div>
            <div class="map-scale-part">
                <label class="map-scale-part-label">{{
                    scaleReadObject.parts[1]
                }}</label>
            </div>
            <div class="map-scale-part">
                <label class="map-scale-part-label">{{
                    scaleReadObject.parts[2]
                }}</label>
            </div>
            <div class="map-scale-part">
                <label class="map-scale-part-label"
                    >{{ scaleReadObject.parts[3] }}
                    <span>{{ scaleReadObject.unit }}</span></label
                >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PrintMapScale',
        props: {
            metersPerPixel: { type: Number, required: true },
            width: { type: Number, required: true },
            scale: { type: Number, required: true }
        },
        computed: {
            scaleDistance: function () {
                return this.metersPerPixel * this.width;
            },
            scaleMod: function () {
                if (this.scaleDistance < 10) {
                    return 4;
                }
                if (this.scaleDistance < 20) {
                    return 9;
                }
                if (this.scaleDistance < 50) {
                    return 12;
                }
                if (this.scaleDistance < 100) {
                    return 24;
                }
                if (this.scaleDistance < 500) {
                    return 60;
                }
                if (this.scaleDistance < 1000) {
                    return 300;
                }
                if (this.scaleDistance < 2000) {
                    return 420;
                }
                if (this.scaleDistance < 3000) {
                    return 600;
                }
                return 3000;
            },
            range: function () {
                return this.scaleDistance - (this.scaleDistance % this.scaleMod);
            },
            scaleWidth: function () {
                const restDistance = this.scaleDistance % this.scaleMod;
                // 5% calculation correction
                return (this.width - restDistance / this.metersPerPixel) * 1.05;
            },
            scalePartWidth: function () {
                return this.range / 3;
            },
            scaleReadObject: function () {
                const unit = this.range >= 1000 ? 'km' : 'm';
                const meters = unit === 'm';
                return {
                    unit,
                    parts: [
                        0,
                        this.scalePartWidth / (meters ? 1 : 1000),
                        (this.scalePartWidth * 2) / (meters ? 1 : 1000),
                        this.range / (meters ? 1 : 1000)
                    ]
                };
            }
        }
    };
</script>

<style scoped lang="scss">
.map-scale-head {
    text-align: center;
    padding-bottom: 0.1em;
}
.map-scale-panel {
    padding: 0 2.5em 0 2.5em;
}
.map-scale {
    display: flex;
    height: 2.4em;
}
.map-scale-part {
    flex-grow: 1;
    height: 1em;
    position: relative;
    background-color: black;
    &:nth-child(2n) {
        background-color: white;
        border-top: 1px solid black;
        border-bottom: 1px solid black;
    }
    &:nth-child(4) {
        flex-grow: 0;
    }
}
.map-scale-part-label {
    position: absolute;
    top: 1.1em;
    transform: translateX(-50%);
    white-space: pre;
    span {
        position: absolute;
    }
}
</style>
